import React from "react";
import { connect } from "react-redux";
import {Tabs} from "antd";

//action imports
import { showNewActivityModal } from "../../actions/ServicesActions";

//component imports
import NewEnquires from "./subComponents/NewEnquires";
import ResolvedEnquiries from "./subComponents/ResolvedEnquiries";

//file imports

const { TabPane } = Tabs;

class Services extends React.Component {

    constructor(props) {
        super(props);

        this.showModal = this.showModal.bind(this);
    }

    showModal = () => {
        this.props.showNewActivityModal();
    };

    render() {
        return(
            <div className={"newCustomerContainer"}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="New" key="1">
                        <NewEnquires/>
                    </TabPane>
                    <TabPane tab="Resolved" key="2">
                        <ResolvedEnquiries/>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default connect(null, { showNewActivityModal })(Services);